import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { ApiStatus } from '../../types/api/status'
import { Store, storeType } from '../../types/slices/storeType'

const initialState: storeType =
{
    status: ApiStatus.FETCHED,
    store: [],
    storeSelected: {} as Store,
    errorMessage: undefined,
    action: ''
}

const storeSlice = createSlice({
    name: 'storeSlice',
    initialState,
    reducers: {
        onFetchStore (state, { payload }: { payload: Store[]}) {
            state.status = ApiStatus.FETCHED
            state.store = payload
            state.errorMessage = undefined
        },
        onSetSelectedStore (state, { payload }: { payload: Store }) {
            state.storeSelected = payload
        },
        changeStatus (state, { payload }: { payload: ApiStatus}){
            state.status = payload
        },
        setAction (state, { payload }: { payload: string }) {
            state.action = payload
        },
    }
})

export const selectStoreState = (state: RootState) => state.storeSlice
export default storeSlice.reducer
export const {
    onFetchStore,
    onSetSelectedStore,
    changeStatus,
    setAction,
} = storeSlice.actions
